import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, MessageCircle } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'Anisley me ayudó a encontrar un plan de salud para toda mi familia que no sabía que existía. Llevaba 3 años sin seguro porque pensaba que no podía pagarlo. Ahora tenemos salud, dental y visión por un precio que jamás imaginé. Gracias de corazón.',
    author: 'María González',
    location: 'Miami, FL',
    role: 'Madre de familia, empleada de restaurante'
  }, {
    text: 'Me llamó, me explicó todo en español, sin prisa y sin presión. Nunca me sentí vendido. Me sentí ayudado. Hoy tengo seguro de vida para proteger a mis hijos y un plan dental que usamos cada 6 meses. Anisley es de las pocas personas que realmente se preocupa por uno.',
    author: 'Roberto Martínez',
    location: 'Houston, TX',
    role: 'Trabajador independiente, construcción'
  }, {
    text: "Yo era de las personas que decía 'los seguros son un gasto'. Hasta que mi esposo tuvo que ir a emergencias y la factura fue de $34,000. Gracias a Dios Anisley nos había conseguido un buen plan meses antes y solo pagamos el copago. Me salvó la vida financieramente.",
    author: 'Carmen Rodríguez',
    location: 'Tampa, FL',
    role: 'Ama de casa, madre de 3 hijos'
  }, {
    text: 'Soy diabético y necesitaba un plan que cubriera mis medicamentos. Anisley encontró exactamente lo que necesitaba. Me ahorró más de $400 al mes en medicinas. No sé qué hubiera hecho sin su ayuda.',
    author: 'José Luis Hernández',
    location: 'Dallas, TX',
    role: 'Conductor de camión, 52 años'
  }, {
    text: 'Llamé sin saber nada de seguros. Anisley me explicó cada detalle con paciencia. En menos de una hora ya tenía mi plan activo. Así de fácil y así de rápido. Ojalá la hubiera encontrado antes.',
    author: 'Andrés Fuentes',
    location: 'Tampa, FL',
    role: 'Empleado de almacén'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-10 md:py-24 bg-navy text-white relative overflow-hidden" data-id="element-354">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-355" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-356" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-357">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-16" data-id="element-358">
          <div className="flex justify-center mb-4" data-id="element-359">
            <MessageCircle className="w-12 h-12 text-gold" data-id="element-360" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-361">
            ESTO ES LO QUE DICEN FAMILIAS COMO LA TUYA...
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-362" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-363">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={itemVariants} className={`bg-navy-light p-8 rounded-2xl border border-white/10 relative ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-364">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-gold/20" data-id="element-365" />

              <div className="flex gap-1 mb-6" data-id="element-366">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-367" />)}
              </div>

              <p className="text-lg text-white/90 mb-8 leading-relaxed italic" data-id="element-368">
                "{testimonial.text}"
              </p>

              <div className="mt-auto border-t border-white/10 pt-4" data-id="element-369">
                <p className="font-serif font-bold text-gold text-lg" data-id="element-370">
                  {testimonial.author}
                </p>
                <p className="text-sm text-white/70" data-id="element-371">{testimonial.location}</p>
                <p className="text-sm text-white/50 mt-1" data-id="element-372">{testimonial.role}</p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}